var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"organism-organization-header"},[_c('img',{staticClass:"organism-organization-header__logo",attrs:{"src":_vm.logoSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }